import React from "react";
import TrackVisibility from "react-on-screen";
import { HomeTitle } from ".";

const WhyUsCard = ({ isVisible, delay, feature }) => {
	const animation = isVisible
		? `opacity-100 animate-animated animate-zoomIn delay-${delay}`
		: "opacity-0";
	return (
		<article
			className={`py-4 px-2 text-center shadow border-t-4 ${feature.color} ${animation}`}
		>
			<div className="mb-6">
				<img
					className="rounded-full w-28 mx-auto"
					src={feature.image}
					alt={feature.title}
				/>
			</div>
			<h3 className="uppercase font-semibold text-xl mb-4">{feature.title}</h3>
			<p className="opacity-70">
				Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit,
				corrupti.
			</p>
		</article>
	);
};

const HomeWhyUs = ({ langWords }) => {
	const features = [
		{
			image: "https://unsplash.it/200/200",
			title: langWords.fullySecure,
			color: "border-adsilTaxi",
		},
		{
			image: "https://unsplash.it/200/200",
			title: langWords.withTheBestPrices,
			color: "border-adsilVTC",
		},
		{
			image: "https://unsplash.it/200/200",
			title: langWords.whithoutWaitingYourTurn,
			color: "border-adsilVIP",
		},
	];
	return (
		<section className="container my-28">
			<HomeTitle title={langWords.ourEffortYouConfort} center />
			<div className="my-8">
				<p
					className="w-full md:w-3/4 text-center md:text-2xl mx-auto opacity-70"
					style={{
						lineHeight: "2.5rem",
					}}
				>
					Lorem ipsum dolor sit amet, consectetur adipisicing elit. Natus animi
					earum cumque placeat? Eius nisi nulla at? Laborum atque optio
					obcaecati fugit dolore. Ipsum amet eius obcaecati sit omnis. Vero.
				</p>
				<div>
					<img
						className="w-full md:w-3/5 mx-auto"
						src="/assets/whyus.png"
						alt="adsilApp"
					/>
				</div>
			</div>
			<div className="bg-g grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 place-content-center gap-6">
				{features.map((feature, id) => (
					<TrackVisibility key={id} once>
						<WhyUsCard feature={feature} delay={id} />
					</TrackVisibility>
				))}
			</div>
		</section>
	);
};

export default HomeWhyUs;
